import { render, staticRenderFns } from "./GetStarted.vue?vue&type=template&id=70220d6a&scoped=true&"
import script from "./GetStarted.vue?vue&type=script&lang=ts&"
export * from "./GetStarted.vue?vue&type=script&lang=ts&"
import style0 from "./GetStarted.vue?vue&type=style&index=0&id=70220d6a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70220d6a",
  null
  
)

export default component.exports